module.exports = __webpack_public_path__ + "img/Bad & Wellness.1ff1d148.jpg";